<div class="rs-are-you-signer">
  <div class="rs-are-you-signer__title rs-step-title">{{'terms-and-agreement.are-you-authorized' | translate}}</div>
  <div class="rs-are-you-signer__actions rs-row">
    <rs-icon-button (click)="reactOnAnswer(true)" [selected]="amIInvitedPerson">{{'terms-and-agreement.yes-i-am' | translate}}</rs-icon-button>
    <rs-icon-button icon="sentiment_dissatisfied" (click)="reactOnAnswer(false)" [selected]="wasAnotherPersonInvited">{{'terms-and-agreement.no' | translate}}</rs-icon-button>
  </div>
</div>
